module.exports = __webpack_public_path__ + "img/DNARepair-BRCA_10X_Section2.34c9f908.png";